module.exports = __webpack_public_path__ + "static/media/banner-of-organizations-details.29b80d76.svg";